import { EngagementAdminConfig } from '@/generated/graphql';
import { configChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';
import { NumericKeys } from '@/types/common';
import { parseNumericConfigInput } from '@/utils/parseNumericConfigInput';
import { CommitOnBlurNumberInput } from './CommitOnBlurNumberInput';

export function NumericConfigInput<TConfig extends EngagementAdminConfig>({
  configKey,
  min = 0,
  max,
  id,
  name,
  className = 'max-w-24',
  fromValue,
  toValue,
}: {
  configKey: NumericKeys<TConfig>;
  min?: number;
  max?: number;
  id?: string;
  name?: string;
  className?: string;
  fromValue?: (value: number | null | undefined) => number;
  toValue?: (value: number) => number;
}) {
  const { state, dispatch } = useAdminEngagementContext();
  const raw = (state.config as TConfig)?.[configKey] as
    | number
    | null
    | undefined;
  const displayValue = fromValue
    ? fromValue(raw)
    : parseNumericConfigInput(String(raw ?? ''), 0);

  return (
    <CommitOnBlurNumberInput
      id={id}
      name={name}
      min={min}
      max={max}
      className={className}
      value={displayValue}
      onCommit={(next) => {
        const committed = toValue ? toValue(next) : next;
        dispatch(configChanged({ config: { [configKey]: committed } }));
      }}
    />
  );
}
